import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";

interface Props {
	label?: string;
	required?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpLabel',
  props: {
    label: null,
    required: { type: Boolean }
  },
  setup(__props: any) {

const { colors } = useColors();



return { __sfc: true,colors, RmpText }
}

})